import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { MeteringPoint, Customer } from '@model';
import { DisturbanceType } from '@enums';

export class CustomerMeteringDisruptionView {
  id: string;
  name: string;
  meteringPoints?: MeteringPoint[];
  _expanded?: boolean;
}

@Component({
    selector: 'app-metering-points-disruptions-pane',
    templateUrl: './metering-points-disruptions-pane.component.html',
    standalone: false
})
export class MeteringPointsDisruptionsPaneComponent implements OnInit, OnChanges {
  @Input()
  customersWithDisruptions: Customer[];
  customersWithMeteringPointDisruptionsView: CustomerMeteringDisruptionView[] = [];

  @Output()
  meteringPointSelected = new EventEmitter<MeteringPoint>();

  DisturbanceTypeEnum = DisturbanceType;

  constructor() {}

  ngOnInit() {
    this.createLocalView();
  }

  ngOnChanges() {
    this.createLocalView();
  }

  createLocalView() {
    if (!this.customersWithDisruptions || this.customersWithDisruptions.length === 0) {
      return;
    }

    this.customersWithMeteringPointDisruptionsView = [];

    this.customersWithDisruptions.forEach(cwd => {
      this.customersWithMeteringPointDisruptionsView.push({
        id: cwd.id,
        meteringPoints: [...cwd.meteringPointsCold, ...cwd.meteringPointsHeat],
        name: cwd.name,
        _expanded: true
      });
    });
  }

  panelOpened(customer: Customer) {
    if (this.customersWithMeteringPointDisruptionsView.some(c => c.id === customer.id)) {
      this.customersWithMeteringPointDisruptionsView.map(item =>
        item.id === customer.id ? (item._expanded = true) : item
      );
    }
  }

  panelClosed(customer: Customer) {
    if (this.customersWithMeteringPointDisruptionsView.some(c => c.id === customer.id)) {
      this.customersWithMeteringPointDisruptionsView.map(item =>
        item.id === customer.id ? (item._expanded = false) : item
      );
    }
  }

  viewInformation = (mp: MeteringPoint) => {
    this.meteringPointSelected.emit(mp);
  };
}
